// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__JhWIn","seoBlock":"styles_seoBlock__ZUMte"};